
<template>
  <div>
    <v-row class="mt-10 justify-center">
      <v-flex lg5 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">담당자명</p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-text-field
          v-model="mallManagerName"
          label="가입할때 등록하신 담당자명을 입력해주세요."
          single-line
          outlined
          dense
        ></v-text-field>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <p class="subtitle-2 font-weight-black mb-1 text-left">이메일 주소</p>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-text-field
          v-model="mallEmail"
          label="가입할때 사용한 이메일 주소를 입력해주세요."
          single-line
          outlined
          dense
        ></v-text-field>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg5 sm10 xs10>
        <v-btn color="primary" class="col-12" height="42" @click="idSearch"
          >아이디 찾기</v-btn
        >
      </v-flex>
    </v-row>

    <v-row class="justify-center mt-6 mb-6">
      <v-flex lg5 sm10 xs10>
        <p
          class="blue--text body-2 mb-0 text-center"
          style="cursor: pointer;"
          @click="moveLoginPage"
        >
          로그인 페이지로 돌아가기
        </p>
      </v-flex>
    </v-row>

    <Alert ref="Alert"></Alert>
  </div>
</template>

<style>
.v-label {
  font-size: 0.8em;
}
</style>
<script>
import M from "@/libs/mapping.js";
import Alert from "@/components/common/Alert.vue";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      passwordShow: false,
      password: "Password",
      mallManagerName: "",
      mallEmail: "",
      alertMessage: ""
    };
  },
  mixins: [CommonMixin],
  methods: {
    idSearch: async function() {
      try {
        await M.api(M.entry("/users/email/send"), {
          mallManagerName: this.mallManagerName,
          mallEmail: this.mallEmail,
          type: "findId"
        });
        this.alertShow(
          "입력하신 이메일 주소로<br>아이디 정보를 발송하였습니다.<br>이메일을 확인해주세요."
        );
      } catch (e) {
        this.alertShow(
          "입력하신 정보가 유효하지 않습니다.<br>다시 확인해주세요."
        );
      }
    },
    moveLoginPage: function() {
      location.href = "/shoplus_service";
    }
  },
  components: {
    Alert
  }
};
</script>